import * as React from 'react';
import logo from "../img/logo.svg";
import MenuIcon from '@mui/icons-material/Menu';
import { useRef } from 'react';
import {Close} from "@mui/icons-material";
import {Button} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import chat_image from "../img/chat2.png";



export default function Root(props) {

  const modalRef = useRef(null);
  const iconRef = useRef(null);
  const [openContactModal, setOpenContactModal] = React.useState(false);

  const openNav = (e) => {
    e.preventDefault();
    console.log(modalRef);
    console.log(iconRef);
    iconRef.current.style.display = 'none';
    modalRef.current.style.width = "100%";
  }

  const closeNav = (e) => {
    iconRef.current.style.display = 'block';
    modalRef.current.style.width = "0%";
  }

  const handleOpenContactModal = () => {
    setOpenContactModal(true);
  };

  const handleCloseContactModal = () => {
    setOpenContactModal(false);
  };

  return (
    <>

      <div ref={modalRef} className="overlay">
        <a className="closebtn" >
          <Close onClick={closeNav}/>
        </a>
        <div className="overlay-content">
          <a href="/">Home</a>
          <a href="/corsi-soccorritori">Soccorritori</a>
          <a href="/sensibilizzazione">Sensibilizzazione</a>
          <a href="/lezioni">Lezioni Guida</a>
          <a href="/moto">Corsi Moto</a>
          <div style={{ display: 'inline-block' }}>
            <Button
              variant="contained"
              className={'whatsapp whatsrapp'}
              size="large"
              style={{ marginRight: '0 !important'}}
              onClick={handleOpenContactModal}
            >
              <img
                style={{ maxWidth: '24px', marginRight: '10px'}}
                src={chat_image}
                alt={'chat'}
              />
              Contattaci
            </Button>
          </div>
        </div>
      </div>

      {props.img === 'video' ?
        <header className={'fit-margin'}>
          <a href={'/'}>
            <img className={'logo-mobile'} src={logo} alt={'test'}/>v
          </a>
          <div ref={iconRef}  className={'menu-icon-mobile'} onClick={(e) => openNav(e)}>
            <MenuIcon type={'button'} />
          </div>
          <video id={'video_background'} autoPlay={true} muted loop className={'header-video'}>
            <source src={'https://res.cloudinary.com/napolinews-it/video/upload/v1687131741/movie_2_rkvsrg.mp4'}
                    type="video/mp4"/>
          </video>
        </header>
        :
        <header>
          <div ref={iconRef}  className={'menu-icon-mobile'} onClick={(e) => openNav(e)}>
            <MenuIcon type={'button'} />
          </div>
        </header>
      }

      <Dialog
        open={openContactModal}
        onClose={handleCloseContactModal}
        maxWidth="xs"
        fullWidth
        style={{ zIndex: 9999 }}
        PaperProps={{
          style: {
            backgroundColor: '#3a3a3a',
            color: 'white',
            margin: '16px',
            width: 'calc(100% - 32px)',
            maxWidth: '400px'
          }
        }}
      >
        <DialogTitle style={{ textAlign: 'center', fontSize: '24px', paddingBottom: '10px' }}>
          Scegli un contatto
        </DialogTitle>
        <DialogContent style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '15px', overflow: 'hidden' }}>
          <a
            href={'https://wa.me/+41774442999'}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none', width: '100%' }}
          >
            <Button
              variant="contained"
              className={'whatsapp'}
              size="large"
              style={{
                justifyContent: 'flex-start',
                padding: '15px',
                width: '100%',
                maxWidth: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}
            >
              <img
                style={{ maxWidth: '24px', marginRight: '10px', flexShrink: 0 }}
                src={chat_image}
                alt={'chat'}
              />
              <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                +41 77 444 29 99 (Sasha)
              </span>
            </Button>
          </a>
          <a
            href={'https://wa.me/+41765599112'}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none', width: '100%' }}
          >
            <Button
              variant="contained"
              className={'whatsapp'}
              size="large"
              style={{
                justifyContent: 'flex-start',
                padding: '15px',
                width: '100%',
                maxWidth: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}
            >
              <img
                style={{ maxWidth: '24px', marginRight: '10px', flexShrink: 0 }}
                src={chat_image}
                alt={'chat'}
              />
              <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                +41 76 559 91 12 (Dejan)
              </span>
            </Button>
          </a>
        </DialogContent>
      </Dialog>
    </>
  );
}
